import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface ChatMessageProps {
    text: string;
    sender: 'User' | 'System';
};
type PlanATripState = ChatMessageProps[];

const initialState: PlanATripState = [{
    text: "Hi there! Could you please tell me the destination you want to travel to, the approximate start date, and the approximate end date of your trip?", sender: "System"
}];

const planATripSlice = createSlice({
    name: 'planATrip',
    initialState,
    reducers:{
        add(state, action: PayloadAction<ChatMessageProps>){
            state.push(action.payload);
        }
    }
});

export const {add} = planATripSlice.actions;
export default planATripSlice.reducer;
